<template lang="html">
  <!-- Content -->
  <d-row>
    <d-col lg="9">
      <d-card class="card-small mb-4">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="6">
              <h6 class="m-0">Dados cadastrais</h6>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <lead-form ref="leadForm"/>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="3" md="12">
      <sidebar-actions :model.sync="lead" @toggleSpam="toggleSpam" @openAssignModal="openAssignModal"/>
    </d-col>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de revendedor"
      message="Tem certeza que deseja excluir esse revendedor?"/>
    <assign-modal :lead="lead" />
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import AssignModal from './AssignModal.vue';
import LeadForm from './LeadForm.vue';
import LeadActions from './LeadActions';
import { _SAVE_LEAD_SUCCESS_ } from './LeadModel';
import SidebarActions from './SidebarActions.vue';

export default {
  name: 'lead-page',
  mixins: [LeadActions],
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  components: {
    Loader,
    LeadForm,
    AssignModal,
    SidebarActions,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      selectLead: null,
    };
  },
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
    ]),
    save() {
      this.$refs.leadForm.save();
      Events.$on(_SAVE_LEAD_SUCCESS_, lead => {
        this.$router.push(`/admin/indicacoes/${lead.id}`);
      });
    },
    openAssignModal() {
      this.setToggle({ type: 'assign_lead_modal', bool: true });
    },
  },
  mounted() {
    this.checkAdmin();
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
